import React, { useState, useRef, useEffect } from 'react';
import './marketingCarousel.css';
import axios from 'axios';

const MarketingCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeState, setFadeState] = useState('in');
  const [marketing, setMarketing] = useState([]);
  const timerRef = useRef(null);
  const nextButtonClick = useRef(false);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_BACKEND_URL + 'shop/MarketingImages',
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((resp) => {
        setMarketing(resp.data.marketing);
      })
      .catch((error) => {
        console.error(error);
      });

    return () => clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    if (marketing.length > 0) {
      timerRef.current = setInterval(() => {
        setFadeState('out');
        setTimeout(() => {
          if (!nextButtonClick.current) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % marketing.length);
          }
          setFadeState('in');
          nextButtonClick.current = false;
        }, 500);
      }, 5000);
    }

    return () => clearInterval(timerRef.current);
  }, [marketing]);

  const handlePrevClick = () => {
    clearInterval(timerRef.current);
    setFadeState('in');
    setTimeout(() => {
      if (marketing.length > 0) {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + marketing.length) % marketing.length);
        timerRef.current = setInterval(() => {
          setFadeState('out');
          setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % marketing.length);
            setFadeState('in');
          }, 300);
        }, 2000);
      }
    }, 500);
  };

  const handleNextClick = () => {
    clearInterval(timerRef.current);
    setFadeState('out');
    setTimeout(() => {
      if (marketing.length > 0) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % marketing.length);
        setFadeState('in');
        nextButtonClick.current = true; // Set the flag for the "Next" button
        timerRef.current = setInterval(() => {
          setFadeState('out');
          setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % marketing.length);
            setFadeState('in');
          }, 300);
        }, 2000);
      }
    }, 500);
  };

  return (
    <div className="carousel-container">
      <div className="carousel-image">
        {marketing.map((image, index) => (
          <img
            key={index}
            src={image.images.url}
            alt={`carousel-${index}`}
            style={{
              display: index === currentIndex ? 'block' : 'none',
              animation: 'fade 1s',
              opacity: index === currentIndex ? 1 : 0.4,
            }}
          />
        ))}
        <style>
          {`
            @keyframes fade {
              from {
                opacity: 0.4;
              }
              to {
                opacity: 1;
              }
            }
          `}
        </style>
        <button className="carousel-prev" onClick={handlePrevClick}>
          ←
        </button>
        <button className="carousel-next" onClick={handleNextClick}>
          →
        </button>
      </div>
    </div>
  );
};

export default MarketingCarousel;
